import { render } from "./Zhibo.vue?vue&type=template&id=050b030c&scoped=true"
import script from "./Zhibo.vue?vue&type=script&lang=js"
export * from "./Zhibo.vue?vue&type=script&lang=js"

import "./Zhibo.vue?vue&type=style&index=0&id=050b030c&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050b030c"]])

export default __exports__